import { render } from "./DraftBookingFlow_baseline.vue?vue&type=template&id=2890ea5f&scoped=true"
import script from "./DraftBookingFlow_baseline.vue?vue&type=script&lang=js"
export * from "./DraftBookingFlow_baseline.vue?vue&type=script&lang=js"

import "./DraftBookingFlow_baseline.vue?vue&type=style&index=0&id=2890ea5f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2890ea5f"]])

export default __exports__